import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'reset-css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false
// 全局过滤器
Vue.filter('toArea', function (value) {
  if (value == "9999") {
    return '';
  } else {
    const areas = {
      "110100": "北京",
      "120100": "天津",
      "130000": "河北省",
      "130100": "石家庄",
      "130200": "唐山",
      "130300": "秦皇岛",
      "130400": "邯郸",
      "130500": "邢台",
      "130600": "保定",
      "130700": "张家口",
      "130800": "承德",
      "130900": "沧州",
      "131000": "廊坊",
      "131100": "衡水",
      "140000": "山西省",
      "140100": "太原",
      "140200": "大同",
      "140300": "阳泉",
      "140400": "长治",
      "140500": "晋城",
      "140600": "朔州",
      "140700": "晋中",
      "140800": "运城",
      "140900": "忻州",
      "141000": "临汾",
      "141100": "吕梁",
      "150000": "内蒙古",
      "150100": "呼和浩特",
      "150200": "包头",
      "150300": "乌海",
      "150400": "赤峰",
      "150500": "通辽",
      "150600": "鄂尔多斯",
      "150700": "呼伦贝尔",
      "150800": "巴彦淖尔",
      "150900": "乌兰察布",
      "152200": "兴安盟",
      "152500": "锡盟",
      "152900": "阿拉善盟",
      "210000": "辽宁省",
      "210100": "沈阳",
      "210200": "大连",
      "210300": "鞍山",
      "210400": "抚顺",
      "210500": "本溪",
      "210600": "丹东",
      "210700": "锦州",
      "210800": "营口",
      "210900": "阜新",
      "211000": "辽阳",
      "211100": "盘锦",
      "211200": "铁岭",
      "211300": "朝阳",
      "211400": "葫芦岛",
      "220000": "吉林省",
      "220100": "长春",
      "220200": "吉林市",
      "220300": "四平",
      "220400": "辽源",
      "220500": "通化",
      "220600": "白山",
      "220700": "松原",
      "220800": "白城",
      "222400": "延边",
      "230000": "黑龙江省",
      "230100": "哈尔滨",
      "230200": "齐齐哈尔",
      "230300": "鸡西",
      "230400": "鹤岗",
      "230500": "双鸭山",
      "230600": "大庆",
      "230700": "伊春",
      "230800": "佳木斯",
      "230900": "七台河",
      "231000": "牡丹江",
      "231100": "黑河",
      "231200": "绥化",
      "232700": "大兴安岭",
      "310100": "上海",
      "320000": "江苏省",
      "320100": "南京",
      "320200": "无锡",
      "320300": "徐州",
      "320400": "常州",
      "320500": "苏州",
      "320600": "南通",
      "320700": "连云港",
      "320800": "淮安",
      "320900": "盐城",
      "321000": "扬州",
      "321100": "镇江",
      "321200": "泰州",
      "321300": "宿迁",
      "330000": "浙江省",
      "330100": "杭州",
      "330200": "宁波",
      "330300": "温州",
      "330400": "嘉兴",
      "330500": "湖州",
      "330600": "绍兴",
      "330700": "金华",
      "330800": "衢州",
      "330900": "舟山",
      "331000": "台州",
      "331100": "丽水",
      "350000": "福建省",
      "350100": "福州",
      "350200": "厦门",
      "350300": "莆田",
      "350400": "三明",
      "350500": "泉州",
      "350600": "漳州",
      "350700": "南平",
      "350800": "龙岩",
      "350900": "宁德",
      "360000": "江西省",
      "360100": "南昌",
      "360200": "景德镇",
      "360300": "萍乡",
      "360400": "九江",
      "360500": "新余",
      "360600": "鹰潭",
      "360700": "赣州",
      "360800": "吉安",
      "360900": "宜春",
      "361000": "抚州",
      "361100": "上饶",
      "370000": "山东省",
      "370100": "济南",
      "370200": "青岛",
      "370300": "淄博",
      "370400": "枣庄",
      "370500": "东营",
      "370600": "烟台",
      "370700": "潍坊",
      "370800": "济宁",
      "370900": "泰安",
      "371000": "威海",
      "371100": "日照",
      "371300": "临沂",
      "371400": "德州",
      "371500": "聊城",
      "371600": "滨州",
      "371700": "菏泽",
      "410000": "河南省",
      "410100": "郑州",
      "410200": "开封",
      "410300": "洛阳",
      "410400": "平顶山",
      "410500": "安阳",
      "410600": "鹤壁",
      "410700": "新乡",
      "410800": "焦作",
      "410900": "濮阳",
      "411000": "许昌",
      "411100": "漯河",
      "411200": "三门峡",
      "411300": "南阳",
      "411400": "商丘",
      "411500": "信阳",
      "411600": "周口",
      "411700": "驻马店",
      "419001": "济源",
      "420000": "湖北省",
      "420100": "武汉",
      "420200": "黄石",
      "420300": "十堰",
      "420500": "宜昌",
      "420600": "襄阳",
      "420700": "鄂州",
      "420800": "荆门",
      "420900": "孝感",
      "421000": "荆州",
      "421100": "黄冈",
      "421200": "咸宁",
      "421300": "随州",
      "422800": "恩施州",
      "429004": "仙桃",
      "429005": "潜江",
      "429006": "天门",
      "429021": "神农架",
      "430000": "湖南省",
      "430100": "长沙",
      "430200": "株洲",
      "430300": "湘潭",
      "430400": "衡阳",
      "430500": "邵阳",
      "430600": "岳阳",
      "430700": "常德",
      "430800": "张家界",
      "430900": "益阳",
      "431000": "郴州",
      "431100": "永州",
      "431200": "怀化",
      "431300": "娄底",
      "433100": "湘西",
      "440000": "广东省",
      "440100": "广州",
      "440200": "韶关",
      "440300": "深圳",
      "440400": "珠海",
      "440500": "汕头",
      "440600": "佛山",
      "440700": "江门",
      "440800": "湛江",
      "440900": "茂名",
      "441200": "肇庆",
      "441300": "惠州",
      "441400": "梅州",
      "441500": "汕尾",
      "441600": "河源",
      "441700": "阳江",
      "441800": "清远",
      "441900": "东莞",
      "442000": "中山",
      "445100": "潮州",
      "445200": "揭阳",
      "445300": "云浮",
      "450000": "广西",
      "450100": "南宁",
      "450200": "柳州",
      "450300": "桂林",
      "450400": "梧州",
      "450500": "北海",
      "450600": "防城港",
      "450700": "钦州",
      "450800": "贵港",
      "450900": "玉林",
      "451000": "百色",
      "451100": "贺州",
      "451200": "河池",
      "451300": "来宾",
      "451400": "崇左",
      "460000": "海南省",
      "460100": "海口",
      "460200": "三亚",
      "460300": "三沙",
      "469001": "五指山",
      "469002": "琼海",
      "469003": "儋州",
      "469005": "文昌",
      "469006": "万宁",
      "469007": "东方",
      "469021": "定安县",
      "469022": "屯昌县",
      "469023": "澄迈县",
      "469024": "临高县",
      "469025": "白沙县",
      "469026": "昌江县",
      "469027": "乐东县",
      "469028": "陵水县",
      "469029": "保亭县",
      "469030": "琼中县",
      "500100": "重庆",
      "510000": "四川省",
      "510100": "成都",
      "510300": "自贡",
      "510400": "攀枝花",
      "510500": "泸州",
      "510600": "德阳",
      "510700": "绵阳",
      "510800": "广元",
      "510900": "遂宁",
      "511000": "内江",
      "511100": "乐山",
      "511300": "南充",
      "511400": "眉山",
      "511500": "宜宾",
      "511600": "广安",
      "511700": "达州",
      "511800": "雅安",
      "511900": "巴中",
      "512000": "资阳",
      "513200": "阿坝",
      "513300": "甘孜",
      "513400": "凉山",
      "520000": "贵州省",
      "520100": "贵阳",
      "520200": "六盘水",
      "520300": "遵义",
      "520400": "安顺",
      "520500": "毕节",
      "520600": "铜仁",
      "522300": "黔西南",
      "522600": "黔东南",
      "522700": "黔南",
      "530000": "云南省",
      "530100": "昆明",
      "530300": "曲靖",
      "530400": "玉溪",
      "530500": "保山",
      "530600": "昭通",
      "530700": "丽江",
      "530800": "普洱",
      "530900": "临沧",
      "532300": "楚雄州",
      "532500": "红河",
      "532600": "文山州",
      "532800": "西双版纳",
      "532900": "大理州",
      "533100": "德宏",
      "533300": "怒江",
      "533400": "迪庆",
      "610000": "陕西省",
      "610100": "西安",
      "610200": "铜川",
      "610300": "宝鸡",
      "610400": "咸阳",
      "610403": "杨陵",
      "610500": "渭南",
      "610600": "延安",
      "610700": "汉中",
      "610800": "甘南",
      "610900": "安康",
      "611000": "商洛",
      "620000": "甘肃省",
      "620100": "兰州",
      "620200": "嘉峪关",
      "620300": "金昌",
      "620400": "白银",
      "620500": "天水",
      "620600": "武威",
      "620700": "张掖",
      "620800": "平凉",
      "620900": "酒泉",
      "621000": "庆阳",
      "621100": "定西",
      "621200": "陇南",
      "622901": "临夏",
      "630000": "青海省",
      "630100": "西宁",
      "632100": "海东",
      "632200": "海北",
      "632300": "黄南",
      "632500": "海南州",
      "632600": "果洛",
      "632700": "玉树",
      "632800": "海西",
      "640000": "宁夏",
      "640100": "银川",
      "640200": "石嘴山",
      "640300": "吴忠",
      "640400": "固原",
      "640500": "中卫",
      "650000": "新疆",
      "650100": "乌鲁木齐",
      "650200": "克拉玛依",
      "652100": "吐鲁番",
      "652200": "哈密",
      "652301": "昌吉",
      "652700": "博尔塔拉",
      "652800": "巴音郭楞",
      "652900": "阿克苏",
      "653000": "克州",
      "653100": "喀什",
      "653200": "和田",
      "654000": "伊犁",
      "654200": "塔城",
      "654300": "阿勒泰",
      "659001": "石河子",
      "659002": "阿拉尔",
      "659003": "图木舒克",
      "659004": "五家渠",
      "659005": "北屯",
      "659006": "铁门关",
      "659007": "双河",
      "659008": "可克达拉",
      "659009": "昆玉",
      "810100": "香港",
      "820100": "香港",
      "830100": "台湾"
    }
    if (value === undefined) {
      // 处理 value 未定义的情况，例如设置一个默认值
      value = '';
    }
    if (value.includes(',')) {
      return value.split(',').map(v => {
        return areas[v] || ''; // 如果 areas[v] 为 undefined，则返回空字符串
      }).join('，');
    } else {
      return areas[value] || ''; // 如果 areas[value] 为 undefined，则返回空字符串
    }
  }
})
Vue.filter('toGender', function (value) {
  if (value == 1) {
    return "男";
  } else {
    return "女";
  }
})
Vue.filter('toAge', function (value) {
  var Zodiac = [
    "猴",
    "鸡",
    "狗",
    "猪",
    "鼠",
    "牛",
    "虎",
    "兔",
    "龙",
    "蛇",
    "马",
    "羊",
  ];
  if (value === '9999') {
    return '';
  } else {
    return (
      new Date().getFullYear() - value + "岁(属" + Zodiac[value % 12] + ")"
    );
  }
})
Vue.filter('toworkYear', function (value) {
  if (value === '') {
    value = new Date().getFullYear();
  }
  const Year = new Date().getFullYear() - value;
  if (Year < 1) {
    return "工作0年";
  } else if (Year > 14) {
    return "工作14年以上";
  } else {
    return "工作" + Year + "年";
  }
})

Vue.filter('toLabel', function (value) {
  if (value == '1') {
    return '战略匹配型'
  } else if (value == '2') {
    return '胜任匹配型'
  } else if (value == '3') {
    return '发展适配型'
  } else if (value == '4') {
    return '暂不匹配型'
  } else {
    return "暂无标签"
  }
})
Vue.filter('toHighest', function (value) {
  if (value === 0) {
    return "";
  } else if (value === 1 || value === '1') {
    return "大专以下";
  } else if (value === 2 || value === '2') {
    return "大专";
  } else if (value === 3 || value === '3') {
    return "本科";
  } else if (value === 4 || value === '4') {
    return "硕士";
  } else if (value === 5 || value === '5') {
    return "博士";
  } else if (value === 6 || value === '6') {
    return "MBA/EMBA";
  }
})
Vue.filter('toCity', function (value, area) {
  if (value.includes(",")) {
    return value
      .split(",")
      .map((part) => area[part])
      .join("，");
  }
  return area[value];
})
Vue.filter('toEmpty', function (value) {
  if (value === "9999") {
    return "";
  }
  return value;
})
Vue.filter('toDegree', function (value) {
  if (value === "1") {
    return "大专以下";
  } else if (value === "2") {
    return "大专";
  } else if (value === "3") {
    return "本科";
  } else if (value === "4") {
    return "硕士";
  } else if (value === "5") {
    return "博士";
  } else if (value === "6") {
    return "MBA/EMBA";
  } else {
    return "";
  }
})
Vue.filter('toChannel', function (value) {
  if (value === 1) {
    return '猎聘';
  } else if (value === 2) {
    return 'Boss';
  } else if (value === 3) {
    return '智联招聘';
  } else if (value === 4) {
    return '系统导入';
  } else {
    return '杭漂人'
  }
})
Vue.filter('tojobStatus', function (value) {
  if (value === 1) {
    return '离职-随时到岗';
  } else if (value === 2) {
    return '在职-暂不考虑';
  } else if (value === 3) {
    return '在职-考虑机会';
  } else {
    return '在职-月内到岗';
  }
})
Vue.filter('toEndTime', function (value, startTime) {
  // 空值检查
  if (!value || !startTime) {
    return value || '';
  }
  try {
    if (value == '9999.0') {
      if (!startTime.includes('.')) return '至今';

      const startYear = parseInt(startTime.substring(0, startTime.indexOf('.')));
      const startMonth = parseInt(startTime.substr(startTime.indexOf('.') + 1));

      if (isNaN(startYear) || isNaN(startMonth)) return '至今';

      const date = new Date();
      const endYear = date.getFullYear();
      const endMonth = date.getMonth() + 1;

      let yearDiff = endYear - startYear;
      let monthDiff;

      if (endMonth < startMonth) {
        yearDiff--;
        monthDiff = (endMonth + 12) - startMonth;
      } else {
        monthDiff = endMonth - startMonth;
      }

      if (yearDiff == 0 && monthDiff != 0) {
        return `至今（${monthDiff}月）`;
      } else if (yearDiff != 0 && monthDiff == 0) {
        return `至今（${yearDiff}年）`;
      } else if (yearDiff <= 0) {
        return '至今';
      } else {
        return `至今（${yearDiff}年${monthDiff}月）`;
      }
    }

    if (!value.includes('.') || !startTime.includes('.')) {
      return value;
    }

    const startYear = parseInt(startTime.substring(0, startTime.indexOf('.')));
    const startMonth = parseInt(startTime.substr(startTime.indexOf('.') + 1));
    const endYear = parseInt(value.substring(0, value.indexOf('.')));
    const endMonth = parseInt(value.substr(value.indexOf('.') + 1));

    if (isNaN(startYear) || isNaN(startMonth) || isNaN(endYear) || isNaN(endMonth)) {
      return value;
    }

    let yearDiff = endYear - startYear;
    let monthDiff;

    if (endMonth < startMonth) {
      yearDiff--;
      monthDiff = (endMonth + 12) - startMonth;
    } else {
      monthDiff = endMonth - startMonth;
    }

    if (yearDiff == 0 && monthDiff != 0) {
      return `${value}（${monthDiff}月）`;
    } else if (yearDiff != 0 && monthDiff == 0) {
      return `${value}（${yearDiff}年）`;
    } else if (yearDiff <= 0) {
      return `${value}`;
    } else {
      return `${value}（${yearDiff}年${monthDiff}月）`;
    }
  } catch (error) {
    // 如果出现任何错误，返回原始值
    console.error('toEndTime filter error:', error);
    return value || '';
  }
})
Vue.filter('toNational', function (value) {
  if (value == '0') {
    return '非统招'
  } else {
    return '统招'
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')